<template>
    <div class="page page__has-bar">
        <div class="page__bd">
            <div class="weui-cells">
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">产品名称</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.productDTO.pr_detail }}
                    </div>
                </div>
                <div class="weui-cell" v-if="source.productDTO.pr_orispeccode">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">型号</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.productDTO.pr_orispeccode }}
                    </div>
                </div>
                <div class="weui-cell" v-if="source.productDTO.pr_spec">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">规格</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.productDTO.pr_spec }}
                    </div>
                </div>
                <div class="weui-cell" v-if="source.productDTO.pr_brand">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">厂家/品牌</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.productDTO.pr_brand }}
                    </div>
                </div>
                <div class="weui-cell" v-if="source.productDTO.pr_zxbzs">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">最小包装数</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.productDTO.pr_zxbzs }}
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">请购数量</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.ad_qty }}
                    </div>
                    <div class="weui-cell__ft">{{ source.productDTO.pr_unit }}</div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">已转采购</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ source.ad_yqty || 0 }}
                    </div>
                    <div class="weui-cell__ft">{{ source.productDTO.pr_unit }}</div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">本次数量</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="number" v-model="target.qty" placeholder="请填写" />
                    </div>
                </div>
                <vendor-field v-model="target.name" @select="onSelectVendor" />
            </div>
        </div>
        <div class="footer-bar weui-dialog__ft">
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">转采购</a>
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
        </div>
    </div>
</template>

<script>
import VendorField from "@/components/field/VendorField.vue";

export default {
    components: {
        VendorField
    },
    data() {
        return {
            source: {},
            target: {
                mode: null,
                qty: 0
            }
        };
    },
    created() {
        let source = this.$route.params.source
        this.source = source
        this.target.qty = source.ad_qty - (source.ad_yqty || 0)
    },
    methods: {
        onSelectVendor(selection) {
            this.target.mode = selection.ve_code;
        },
        save() {
            var me = this, source = me.source, target = me.target;
            if (!target.qty) {
                me.$weui.topTips('请填写数量', 2000)
                return
            } else if (!target.mode) {
                me.$weui.topTips('请选择供应商', 2000)
                return
            } else {
                me.$loading({
                    url: "/api/purchase/application/applicationTurnPurchase",
                    method: 'POST',
                    jsonData: {
                        mode: target.mode,
                        baseDTOs: [{
                            id: source.id,
                            qty: target.qty
                        }]
                    }
                }).then(function (res) {
                    if (res.success) {
                        me.$weui.toast("转采购成功", 2000)
                        me.$router.back()
                    } else {
                        me.$weui.topTips(res.message || "转采购失败", 3000)
                    }
                });
            }
        }
    },
};
</script>